<div class="content-wrapper-inner">
  <header class="news-head">
    <h1>News</h1>
    <p class="news-head__subtitle">Product announcements and platform updates from the TelQ team.</p>
  </header>

  @if (featured(); as item) {
    <article class="news-hero">
      <div class="news-hero__body">
        <div class="news-hero__eyebrow">
          <span class="news-hero__category">{{ item.category }}</span>
          <span class="news-badge">New</span>
        </div>

        <h2 class="news-hero__title">{{ item.title }}</h2>
        <p class="news-hero__summary">{{ item.summary }}</p>

        @for (paragraph of item.details; track $index) {
          <p class="news-hero__detail">{{ paragraph }}</p>
        }

        <div class="news-hero__footer">
          @if (item.link) {
            <!-- rel is deliberately "noopener" only: "noreferrer" would strip the referrer
                 header, which is the fallback attribution signal if the UTM params get lost. -->
            <a class="btn btn-primary news-hero__cta" [href]="item.link.url" target="_blank" rel="noopener" (click)="onNewsLinkClick(item)">
              {{ item.link.label }}
              <span class="icon-arrow-right-plain news-hero__cta-icon" aria-hidden="true"></span>
            </a>
          }
          <time class="news-date" [attr.datetime]="item.publishedOn">{{ item.publishedOn | date: 'MMMM d, y' }}</time>
        </div>
      </div>
    </article>
  }

  <div class="news-feed">
    @for (item of entries(); track item.id) {
      <article class="news-card">
        <div class="news-card__meta">
          <span class="news-card__category">{{ item.category }}</span>
          <time class="news-date" [attr.datetime]="item.publishedOn">{{ item.publishedOn | date: 'MMMM d, y' }}</time>
        </div>

        <h2 class="news-card__title">{{ item.title }}</h2>
        <p class="news-card__summary">{{ item.summary }}</p>

        @for (paragraph of item.details; track $index) {
          <p class="news-card__detail">{{ paragraph }}</p>
        }

        @if (item.link) {
          <a class="news-card__link" [href]="item.link.url" target="_blank" rel="noopener" (click)="onNewsLinkClick(item)">
            {{ item.link.label }}
            <span class="icon-arrow-right-plain news-card__link-icon" aria-hidden="true"></span>
          </a>
        }
      </article>
    }
  </div>
</div>
